import React from 'react';
import './PeriodSelector.css';

const defaultPeriods = [
  { label: 'All time', value: 'all_time' },
  { label: 'Year', value: 'year' },
  { label: 'Month', value: 'month' },
  { label: 'Today', value: 'today' },
  { label: 'Custom', value: 'custom' },
];

interface PeriodSelectorProps {
  selectedPeriod: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  periods?: { label: string; value: string }[];
}

export default function PeriodSelector({ selectedPeriod, onChange, periods }: PeriodSelectorProps) {
  const options = periods || defaultPeriods;
  return (
    <div className="period-selector">
      {options.map(({ label, value }) => (
        <label
          key={value}
          className={`period-option${selectedPeriod === value ? ' selected' : ''}`}
        >
          <input
            type="radio"
            name="period"
            value={value}
            checked={selectedPeriod === value}
            onChange={onChange}
          />
          {label}
        </label>
      ))}
    </div>
  );
}
